
import { defineComponent, PropType } from "vue";
import Button from "./Button.vue";

export default defineComponent({
  props: {
    direction: {
      type: String,
      default: () => "horizontal",
      validator: (value: string) => {
        return ["horizontal", "vertical"].indexOf(value) !== -1;
      },
    },
    modelValue: {
      type: [Number, String] as PropType<any>,
      default: () => null,
    },
    // If true modelValue should be an array
    multiple: {
      type: Boolean,
      default: () => false,
    },
    options: {
      type: Object as PropType<any[]>,
      required: true,
    },
    valueProp: {
      type: String,
      default: () => "id",
    },
    // If true, modelValue should be an object
    object: {
      type: Boolean,
      default: () => false,
    },
    color: {
      type: String,
      default: () => "blue",
      validator: (value: string) => {
        // The value must match one of these strings
        return (
          [
            "primary",
            "secondary",
            "accent",
            "gray",
            "blue",
            "green",
            "red",
            "white",
            "yellow",
            "black-white",
            "white-black",
          ].indexOf(value) !== -1
        );
      },
    },
    rounded: {
      type: Boolean,
      default: () => false,
    },
    noSelected: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const select = (option: { [key: string]: number }) => {
      context.emit(
        "update:modelValue",
        props.object ? option : option[props.valueProp]
      );
    };

    const getClasses = (option: { [key: string]: number }) => {
      const classes = ["button", `button button--${props.color}`];

      if (
        Array.isArray(props.modelValue) &&
        props.modelValue.find((value) => value === option[props.valueProp])
      ) {
        classes.push("selected");
      } else if (
        option[props.valueProp] === props.modelValue &&
        !props.noSelected
      ) {
        classes.push("selected");
      }

      return classes;
    };

    return {
      select,
      getClasses,
    };
  },
  components: { Button },
});
